module.exports = __webpack_public_path__ + "static/media/loading.9075d9a6.svg";